var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Text-File--Streamline-Flex-Gradient.svg",
    height: 50,
    width: 50,
    strokeWidth: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Text File Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text-file--text-common-file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "url(#paint0_linear_7718_2252)",
    fillRule: "evenodd",
    d: "M7.00004.143555c-1.48865 0-2.68395.046117-3.93111.133915C1.85686.362798.892448 1.32793.814366 2.54265.721945 3.98046.67334 5.47157.67334 6.99995c0 1.52839.048605 3.01945.141027 4.45735.078081 1.2147 1.042503 2.1798 2.254563 2.2651 1.24716.0878 2.44246.134 3.93111.134 1.48865 0 2.68395-.0462 3.93116-.134 1.212-.0853 2.1764-1.0504 2.2545-2.2651.0924-1.4379.141-2.92896.141-4.45735 0-.4127-.0035-.82267-.0105-1.22961-.0151-.87934-.2957-1.74682-.8424-2.4556-.8183-1.06075-1.5573-1.80326-2.67974-2.666426C9.38915.336931 8.89641.16986 8.39296.15852c-.44085-.00993-.901-.014965-1.39292-.014965ZM4.14209 7.01562c0-.34517.27982-.625.625-.625h3.8125c.34518 0 .625.27983.625.625 0 .34518-.27982.625-.625.625h-3.8125c-.34518 0-.625-.27982-.625-.625Zm.625-3.64062c-.34518 0-.625.27982-.625.625s.27982.625.625.625h2.30065c.34517 0 .625-.27982.625-.625s-.27983-.625-.625-.625H4.76709Zm0 5.92185c-.34518 0-.625.27982-.625.625 0 .34515.27982.62495.625.62495h3.80065c.34517 0 .625-.2798.625-.62495 0-.34518-.27983-.625-.625-.625H4.76709Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7718_2252",
    x1: 1.16,
    x2: 16.117,
    y1: 1.252,
    y2: 9.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3edf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b1cc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.8114dd6260898556f05cf4a74bdf6925.svg";
export { ForwardRef as ReactComponent };